<template>
  <section>
    <div class="pt-10 pb-5 bg-white">
      <section>
        <div
          v-for="(sideProgram, index) in sidePrograms"
          :key="index"
          :class="{ 'border-solid border-b md:border-b-2 border-app-primary-grey--concrete pb-6 mb-6': index < sidePrograms.length - 1 }"
        >
          <MoleculeEventDetailPageTitleV2 v-if="sideProgram.title" class="text-app-secondary-9-green--sherpa-blue" :title="sideProgram.title" />
          <div class="text-base flex items-center">
            <div class="flex-auto">
              <h4 v-if="sideProgram.label" class="font-semibold mb-2">{{ sideProgram.label }}</h4>
              <span v-if="sideProgram.introduction" class="text-base" v-html="sideProgram.introduction" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  sidePrograms: { type: Array as PropType<any[]>, required: false, default: () => [] },
})
</script>
